export default __webpack_public_path__ + "static/gate-8fb57309696c3225aabd51a0a79b3cc8.svg";